var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgInstagramSquare = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.38a2.62 2.62 0 10.004 5.24A2.62 2.62 0 0011 8.38zm6.124-2.013a2.65 2.65 0 00-1.493-1.493C14.6 4.467 12.144 4.558 11 4.558c-1.144 0-3.597-.095-4.631.316-.683.27-1.224.81-1.494 1.493C4.47 7.398 4.56 9.857 4.56 11c0 1.143-.091 3.598.317 4.632.27.683.81 1.224 1.494 1.494 1.03.407 3.486.315 4.631.315s3.597.095 4.63-.315a2.648 2.648 0 001.494-1.494c.41-1.031.316-3.489.316-4.632 0-1.143.094-3.598-.316-4.632h-.002zM11 15.027a4.027 4.027 0 110-8.054 4.027 4.027 0 010 8.054zm4.193-7.283a.94.94 0 11.666-.274.936.936 0 01-.664.276l-.002-.002zM19.643 0H2.357A2.357 2.357 0 000 2.357v17.286A2.357 2.357 0 002.357 22h17.286A2.357 2.357 0 0022 19.643V2.357A2.357 2.357 0 0019.643 0zm-.84 14.241c-.064 1.259-.351 2.374-1.27 3.29-.92.917-2.033 1.21-3.29 1.27-1.297.073-5.186.073-6.483 0-1.258-.064-2.37-.351-3.29-1.27-.92-.918-1.21-2.034-1.27-3.29-.072-1.297-.072-5.186 0-6.482.064-1.259.348-2.374 1.27-3.29.922-.917 2.037-1.206 3.29-1.266 1.297-.073 5.186-.073 6.483 0 1.258.063 2.373.35 3.29 1.27.917.917 1.21 2.033 1.27 3.292.072 1.292.072 5.178 0 6.476z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstagramSquare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instagram-square.610a8994.svg";
export { ForwardRef as ReactComponent };